import { useCallback, useEffect, useMemo } from 'react'
import API from '../services/api'
import useAPIRequest from './useAPIRequest'

export const useExcoConfig = () => {
  const callback = useCallback(() => {
    return API.getExcoConfig()
  }, [])

  const [{ inProgress, data, error }, doAPIRequest] = useAPIRequest<API.ExcoConfigResponse[]>(callback, null)

  useEffect(() => {
    doAPIRequest()
  }, [doAPIRequest])

  return useMemo(() => ({
    inProgress,
    data,
    error,
    refresh: doAPIRequest,
  }), [
    inProgress,
    data,
    error,
    doAPIRequest
  ])
}
